import { useState } from 'react';
import { Link, router } from '@inertiajs/react';
import TeacherShell, { TeacherPageHeader } from '../../../components/layout/TeacherShell';
import { Card, Button, Input, Textarea } from '../../../components/ui';

export default function BookSeriesEdit({ series }) {
  const [name, setName] = useState(series.name || '');
  const [author, setAuthor] = useState(series.author || '');
  const [description, setDescription] = useState(series.description || '');
  const [saving, setSaving] = useState(false);

  const hasChanges =
    name.trim() !== (series.name || '') ||
    (author.trim() || '') !== (series.author || '') ||
    (description.trim() || '') !== (series.description || '');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim() || saving) return;
    setSaving(true);
    router.patch(
      `/teacher/book_series/${series.id}`,
      { book_series: { name: name.trim(), author: author.trim() || null, description: description.trim() || null } },
      { onFinish: () => setSaving(false) }
    );
  };

  const scrollTitle = (
    <>
      <Link href="/teacher/book_series" className="hover:text-blue-600 dark:hover:text-blue-400">
        Series
      </Link>
      {'  ›  '}
      <Link
        href={`/teacher/book_series/${series.id}`}
        className="hover:text-blue-600 dark:hover:text-blue-400"
      >
        {series.name}
      </Link>
      {'  ›  Edit'}
    </>
  );

  return (
    <TeacherShell scrollTitle={scrollTitle}>
      <TeacherPageHeader
        title="Edit Series"
        subtitle={series.name}
        backLink={`/teacher/book_series/${series.id}`}
        backLabel={series.name}
      />

      <div className="max-w-lg">
        <Card className="p-6">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Name <span className="text-red-500">*</span>
              </label>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                autoFocus
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Author
              </label>
              <Input
                value={author}
                onChange={(e) => setAuthor(e.target.value)}
                placeholder="Optional — useful when every book shares an author"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Description
              </label>
              <Textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={3}
                placeholder="Optional"
              />
            </div>

            <div className="flex items-center gap-3 pt-1">
              <Button type="submit" disabled={saving || !name.trim() || !hasChanges}>
                {saving ? 'Saving…' : 'Save changes'}
              </Button>
              <Link href={`/teacher/book_series/${series.id}`}>
                <Button type="button" variant="secondary">Cancel</Button>
              </Link>
            </div>
          </form>
        </Card>
      </div>
    </TeacherShell>
  );
}
